import { useMutation, useQuery } from '@tanstack/react-query';
import api from '../axios';
import { getErrorResponse } from '@src/types';

export const useImagesEventsById = (EventId: number) => {
    return useQuery({
        queryKey: ['ImagesEventById', EventId],
        queryFn: async () => {
            try {
                const { data } = await api.get(`/events/${EventId}/images`);
                return data;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },
        enabled: !!EventId,
    });
};

export const useDeleteImagesById = () => {
    return useMutation({
        mutationFn: async (id: number) => {
            try {
                const { data, status } = await api.delete(`/images/${id}`);
                return {
                    data,
                    status,
                };
            } catch (error) {
                return getErrorResponse(error);
            }
        },
    });
};
